/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import type { DmlsOptions, Territory, VinylAmznPlayer } from '@amzn/vinyl-amzn'
import { getUserAgentInfo } from '@amazon/vinyl-util'
import { getAuth } from '@/auth/authRef'
import { getCodeData } from '@/auth/createCodeData'
import { getCustomer } from '@/customer/customer'

/**
 * Creates the DMLS options for the current customer.
 */
export async function createDmlsOptions(player: VinylAmznPlayer): Promise<DmlsOptions> {
    const { entitlementList, customerHome } = await getCustomer()
    const codeData = getCodeData()

    return {
        enableFlacOpus: player.capabilities.canPlayTypeMse('audio/mp4;codecs="opus"'),
        marketplaceId: customerHome.marketplaceId,
        musicTerritory: customerHome.musicTerritory as Territory,
        appMetadata: {
            appId: codeData.app_name!,
            https: true,
            appVersion: codeData.app_version,
            userAgent: getUserAgentInfo().userAgent,
        },
        deviceToken: {
            deviceId: codeData.device_serial,
            deviceTypeId: codeData.device_type,
        },
        clientMetadata: {
            clientId: codeData.app_name!,
        },
        host: 'https://music.amazon.com',
        customer: {
            oAuthTokenProvider: getAuth().authTokenProvider,
            customerId: customerHome.customerId,
            entitlementList,
        },
        firefoxClearLeadEnabled: true,
    }
}
